import { AccountWithoutRegistrationRequiredFieldsEnum } from 'shared/api';

export type BookingSmsConsentOrgFields = {
  readonly settings_booking_sms_consent_enabled?: boolean | null;
  readonly booking_sms_consent_label?: string | null;
  readonly account_without_registration_required_fields?:
    | AccountWithoutRegistrationRequiredFieldsEnum
    | null;
};

export function isPhoneCollectedOnFastRegistration(
  requiredFields: BookingSmsConsentOrgFields['account_without_registration_required_fields']
): boolean {
  const v = requiredFields ?? undefined;
  return (
    v === AccountWithoutRegistrationRequiredFieldsEnum.Phone ||
    v === AccountWithoutRegistrationRequiredFieldsEnum.EmailAndPhone
  );
}

/** Trimmed primary label; empty if missing or whitespace-only. */
export function getBookingSmsConsentLabelTrimmed(
  label: string | null | undefined
): string {
  return (label ?? '').trim();
}

/**
 * Show SMS consent checkbox: feature on, phone on step, non-empty label.
 */
export function shouldShowBookingSmsConsentCheckbox(
  org: BookingSmsConsentOrgFields
): boolean {
  if (org.settings_booking_sms_consent_enabled !== true) return false;
  if (!isPhoneCollectedOnFastRegistration(org.account_without_registration_required_fields)) {
    return false;
  }
  return getBookingSmsConsentLabelTrimmed(org.booking_sms_consent_label).length > 0;
}

/**
 * Feature on + phone step but label empty — admin misconfiguration.
 */
export function isBookingSmsConsentMisconfigured(
  org: BookingSmsConsentOrgFields
): boolean {
  if (org.settings_booking_sms_consent_enabled !== true) return false;
  if (!isPhoneCollectedOnFastRegistration(org.account_without_registration_required_fields)) {
    return false;
  }
  return getBookingSmsConsentLabelTrimmed(org.booking_sms_consent_label).length === 0;
}
